"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

var _typeof3 = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/typeof.js");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/typeof.js"));

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/web.dom.iterable");

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

var _user = _interopRequireDefault(require("@/api/system/user"));

var _validate = require("@/utils/validate");

var _dept = require("@/api/system/dept");

var _role = require("@/api/system/role");

var _job = require("@/api/system/job");

var _crud = _interopRequireWildcard(require("@crud/crud"));

var _RR = _interopRequireDefault(require("@crud/RR.operation"));

var _CRUD = _interopRequireDefault(require("@crud/CRUD.operation"));

var _UD = _interopRequireDefault(require("@crud/UD.operation"));

var _Pagination = _interopRequireDefault(require("@crud/Pagination"));

var _DateRangePicker = _interopRequireDefault(require("@/components/DateRangePicker"));

var _vueTreeselect = _interopRequireWildcard(require("@riophae/vue-treeselect"));

var _vuex = require("vuex");

require("@riophae/vue-treeselect/dist/vue-treeselect.css");

var _methods;

function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var userRoles = [];
var userJobs = [];
var defaultForm = {
  id: null,
  username: null,
  nickName: null,
  gender: '男',
  email: null,
  enabled: 'false',
  roles: [],
  jobs: [],
  dept: {
    id: null
  },
  phone: null
};
var _default = {
  name: 'User',
  components: {
    Treeselect: _vueTreeselect.default,
    crudOperation: _CRUD.default,
    rrOperation: _RR.default,
    udOperation: _UD.default,
    pagination: _Pagination.default,
    DateRangePicker: _DateRangePicker.default
  },
  cruds: function cruds() {
    return (0, _crud.default)({
      title: '用户',
      url: 'api/users',
      crudMethod: _objectSpread({}, _user.default)
    });
  },
  mixins: [(0, _crud.presenter)(), (0, _crud.header)(), (0, _crud.form)(defaultForm), (0, _crud.crud)()],
  // 数据字典
  dicts: ['user_status'],
  data: function data() {
    // 自定义验证
    var validPhone = function validPhone(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入电话号码'));
      } else if (!(0, _validate.isvalidPhone)(value)) {
        callback(new Error('请输入正确的11位手机号码'));
      } else {
        callback();
      }
    };

    return {
      height: document.documentElement.clientHeight - 180 + 'px;',
      deptName: '',
      depts: [],
      deptDatas: [],
      jobs: [],
      level: 3,
      roles: [],
      jobDatas: [],
      roleDatas: [],
      // 多选时使用
      defaultProps: {
        children: 'children',
        label: 'name',
        isLeaf: 'leaf'
      },
      permission: {
        add: ['admin', 'user:add'],
        edit: ['admin', 'user:edit'],
        del: ['admin', 'user:del']
      },
      enabledTypeOptions: [{
        key: 'true',
        display_name: '激活'
      }, {
        key: 'false',
        display_name: '锁定'
      }],
      rules: {
        username: [{
          required: true,
          message: '请输入用户名',
          trigger: 'blur'
        }, {
          min: 2,
          max: 20,
          message: '长度在 2 到 20 个字符',
          trigger: 'blur'
        }],
        nickName: [{
          required: true,
          message: '请输入用户昵称',
          trigger: 'blur'
        }, {
          min: 2,
          max: 20,
          message: '长度在 2 到 20 个字符',
          trigger: 'blur'
        }],
        email: [{
          required: true,
          message: '请输入邮箱地址',
          trigger: 'blur'
        }, {
          type: 'email',
          message: '请输入正确的邮箱地址',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          trigger: 'blur',
          validator: validPhone
        }]
      }
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['user'])),
  created: function created() {
    this.crud.msg.add = '新增成功，默认密码：123456';
  },
  mounted: function mounted() {
    var that = this;

    window.onresize = function temp() {
      that.height = document.documentElement.clientHeight - 180 + 'px;';
    };
  },
  methods: (_methods = {
    changeRole: function changeRole(value) {
      userRoles = [];
      value.forEach(function (data, index) {
        var role = {
          id: data
        };
        userRoles.push(role);
      });
    },
    changeJob: function changeJob(value) {
      userJobs = [];
      value.forEach(function (data, index) {
        var job = {
          id: data
        };
        userJobs.push(job);
      });
    },
    deleteTag: function deleteTag(value) {
      userRoles.forEach(function (data, index) {
        if (data.id === value) {
          userRoles.splice(index, value);
        }
      });
    }
  }, (0, _defineProperty2.default)(_methods, _crud.default.HOOK.afterToCU, function (crud, form) {
    this.getRoles();

    if (form.id == null) {
      this.getDepts();
    } else {
      this.getSupDepts(form.dept.id);
    }

    this.getRoleLevel();
    this.getJobs();
    form.enabled = form.enabled.toString();
  }), (0, _defineProperty2.default)(_methods, _crud.default.HOOK.beforeToAdd, function () {
    this.jobDatas = [];
    this.roleDatas = [];
  }), (0, _defineProperty2.default)(_methods, _crud.default.HOOK.beforeToEdit, function (crud, form) {
    this.getJobs(this.form.dept.id);
    this.jobDatas = [];
    this.roleDatas = [];
    userRoles = [];
    userJobs = [];

    var _this = this;

    form.roles.forEach(function (role, index) {
      _this.roleDatas.push(role.id);

      var rol = {
        id: role.id
      };
      userRoles.push(rol);
    });
    form.jobs.forEach(function (job, index) {
      _this.jobDatas.push(job.id);

      var data = {
        id: job.id
      };
      userJobs.push(data);
    });
  }), (0, _defineProperty2.default)(_methods, _crud.default.HOOK.afterValidateCU, function (crud) {
    if (!crud.form.dept.id) {
      this.$message({
        message: '部门不能为空',
        type: 'warning'
      });
      return false;
    } else if (this.jobDatas.length === 0) {
      this.$message({
        message: '岗位不能为空',
        type: 'warning'
      });
      return false;
    } else if (this.roleDatas.length === 0) {
      this.$message({
        message: '角色不能为空',
        type: 'warning'
      });
      return false;
    }

    crud.form.roles = userRoles;
    crud.form.jobs = userJobs;
    return true;
  }), (0, _defineProperty2.default)(_methods, "getDeptDatas", function getDeptDatas(node, resolve) {
    var _this2 = this;

    var sort = 'id,desc';
    var params = {
      sort: sort
    };

    if ((0, _typeof2.default)(node) !== 'object') {
      if (node) {
        params['name'] = node;
      }
    } else if (node.level !== 0) {
      params['pid'] = node.data.id;
    }

    setTimeout(function () {
      (0, _dept.getDepts)(params).then(function (res) {
        if (resolve) {
          resolve(res.content);
        } else {
          _this2.deptDatas = res.content;
        }
      });
    }, 100);
  }), (0, _defineProperty2.default)(_methods, "getDepts", function getDepts() {
    var _this3 = this;

    (0, _dept.getDepts)({
      enabled: true
    }).then(function (res) {
      _this3.depts = res.content.map(function (obj) {
        if (obj.hasChildren) {
          obj.children = null;
        }

        return obj;
      });
    });
  }), (0, _defineProperty2.default)(_methods, "getSupDepts", function getSupDepts(deptId) {
    var _this4 = this;

    (0, _dept.getDeptSuperior)(deptId).then(function (res) {
      var date = res.content;

      _this4.buildDepts(date);

      _this4.depts = date;
    });
  }), (0, _defineProperty2.default)(_methods, "buildDepts", function buildDepts(depts) {
    var _this5 = this;

    depts.forEach(function (data) {
      if (data.children) {
        _this5.buildDepts(data.children);
      }

      if (data.hasChildren && !data.children) {
        data.children = null;
      }
    });
  }), (0, _defineProperty2.default)(_methods, "loadDepts", function loadDepts(_ref) {
    var action = _ref.action,
        parentNode = _ref.parentNode,
        callback = _ref.callback;

    if (action === _vueTreeselect.LOAD_CHILDREN_OPTIONS) {
      (0, _dept.getDepts)({
        enabled: true,
        pid: parentNode.id
      }).then(function (res) {
        parentNode.children = res.content.map(function (obj) {
          if (obj.hasChildren) {
            obj.children = null;
          }

          return obj;
        });
        setTimeout(function () {
          callback();
        }, 200);
      });
    }
  }), (0, _defineProperty2.default)(_methods, "handleNodeClick", function handleNodeClick(data) {
    if (data.pid === 0) {
      this.query.deptId = null;
    } else {
      this.query.deptId = data.id;
    }

    this.crud.toQuery();
  }), (0, _defineProperty2.default)(_methods, "changeEnabled", function changeEnabled(data, val) {
    var _this6 = this;

    this.$confirm('此操作将 "' + this.dict.label.user_status[val] + '" ' + data.username + ', 是否继续？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(function () {
      _user.default.edit(data).then(function (res) {
        _this6.crud.notify(_this6.dict.label.user_status[val] + '成功', _crud.default.NOTIFICATION_TYPE.SUCCESS);
      }).catch(function () {
        data.enabled = !data.enabled;
      });
    }).catch(function () {
      data.enabled = !data.enabled;
    });
  }), (0, _defineProperty2.default)(_methods, "getRoles", function getRoles() {
    var _this7 = this;

    (0, _role.getAll)().then(function (res) {
      _this7.roles = res;
    }).catch(function () {});
  }), (0, _defineProperty2.default)(_methods, "getJobs", function getJobs() {
    var _this8 = this;

    (0, _job.getAllJob)().then(function (res) {
      _this8.jobs = res.content;
    }).catch(function () {});
  }), (0, _defineProperty2.default)(_methods, "getRoleLevel", function getRoleLevel() {
    var _this9 = this;

    (0, _role.getLevel)().then(function (res) {
      _this9.level = res.level;
    }).catch(function () {});
  }), (0, _defineProperty2.default)(_methods, "checkboxT", function checkboxT(row, rowIndex) {
    return row.id !== this.user.id;
  }), _methods)
};
exports.default = _default;